<div class="c-pagination-pages">
  <!--   <label class="c-pagination-pages__label me-3" for="selectPages">Mostrar </label> -->
  <!-- ms-2 me-2 -->
  <select
    class="c-pagination-pages__select custom-select form-control-sm"
    id="selectPages"
    [ngModel]="filtros().limit"
    (change)="pageOnChange($event)"
    [disabled]="disabled()"
  >
    @for (ps of pageSizesSelect(); track ps) {
      <!-- *ngFor="let ps of pageSizesSelect()" -->
      <option [value]="ps">
        {{ ps }}
      </option>
    }
  </select>
  <label class="c-pagination-pages__label ms-2" for="selectPages">
    Datos por página</label
  >
</div>
